"use client";

import StepMarker from "./StepMarker";
import { Button } from "./Button";

export default function Step2ContactDetails({
  formData,
  updateFormData,
  onBack,
  onNext,
}) {
  const handleChange = (e) => {
    updateFormData({ [e.target.name]: e.target.value });
  };

  const isValid = formData.contactemail && formData.contactphone;

  return (
    <div>
      <StepMarker currentStep={2} totalSteps={5} onBack={onBack} />

      <h2 className="text-2xl font-bold mb-1">Contact Information</h2>
      <p className="text-gray-500 mb-6">How can customers reach you?</p>

      <div className="space-y-4">
        <div>
          <input
            id="contactemail"
            name="contactemail"
            type="email"
            value={formData.contactemail || ""}
            onChange={handleChange}
            placeholder="Contact Email*"
            className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#7B189F] focus:border-transparent"
            required
          />
        </div>

        <div>
          <input
            id="contactphone"
            name="contactphone"
            type="tel"
            value={formData.contactphone || ""}
            onChange={handleChange}
            placeholder="Primary Phone Number*"
            className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#7B189F] focus:border-transparent"
            required
          />
        </div>

        <div>
          <input
            id="contactotherphone"
            name="contactotherphone"
            type="tel"
            value={formData.contactotherphone || ""}
            onChange={handleChange}
            placeholder="Alternative Phone Number (Optional)"
            className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#7B189F] focus:border-transparent"
          />
        </div>
      </div>

      <div className="flex justify-between mt-8">
        <Button variant="outline" onClick={onBack}>
          Back
        </Button>
        <Button onClick={onNext} disabled={!isValid} className="px-8">
          Continue
        </Button>
      </div>
    </div>
  );
}
